var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2997 6.20971C18.1129 6.02246 17.8592 5.91723 17.5947 5.91723C17.3302 5.91723 17.0766 6.02246 16.8897 6.20971L11.9997 11.0897L7.10973 6.19971C6.9229 6.01246 6.66924 5.90723 6.40473 5.90723C6.14021 5.90723 5.88656 6.01246 5.69973 6.19971C5.30973 6.58971 5.30973 7.21971 5.69973 7.60971L10.5897 12.4997L5.69973 17.3897C5.30973 17.7797 5.30973 18.4097 5.69973 18.7997C6.08973 19.1897 6.71973 19.1897 7.10973 18.7997L11.9997 13.9097L16.8897 18.7997C17.2797 19.1897 17.9097 19.1897 18.2997 18.7997C18.6897 18.4097 18.6897 17.7797 18.2997 17.3897L13.4097 12.4997L18.2997 7.60971C18.6797 7.22971 18.6797 6.58971 18.2997 6.20971Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.28dc742fbeabffc2973d252dee31765b.svg";
export { ForwardRef as ReactComponent };